import {
    SET_INITIAL_PROJECT,
    FETCH_CURRENT_PROJECT_REQUEST,
    FETCH_CURRENT_PROJECT_SUCCESS,
    FETCH_CURRENT_PROJECT_FAILURE,

    FETCH_PROJECTS_REQUEST,
    FETCH_PROJECTS_SUCCESS,
    FETCH_PROJECTS_FAILURE,

    CREATE_PROJECT_REQUEST,
    CREATE_PROJECT_SUCCESS,
    CREATE_PROJECT_FAILURE,

    SET_CURRENT_PROJECT_REQUEST,
    SET_CURRENT_PROJECT_SUCCESS,
    SET_CURRENT_PROJECT_FAILURE,

    SET_PROJECT_STRUCTURE,

    UPDATE_PROJECT_REQUEST,
    UPDATE_PROJECT_SUCCESS,
    UPDATE_PROJECT_FAILURE,

    DELETE_PROJECT_REQUEST,
    DELETE_PROJECT_SUCCESS,
    DELETE_PROJECT_FAILURE,

    MOVE_PROJECT_RESOURCES_REQUEST,
    MOVE_PROJECT_RESOURCES_SUCCESS,
    MOVE_PROJECT_RESOURCES_FAILURE,

    KANBAN_SCROLL_POSITION_UPDATE,
} from './Types';

import { AppDispatch } from '../Store';
import axios, { Canceler } from 'axios';
import { setSiteCards } from '../site_card/Actions';
import { Project } from './projectTypes';
const CancelToken = axios.CancelToken;

let
    cancelFetchAllProjects: Canceler,
    cancelFetchCurrentProject: Canceler,
    cancelCreateProject,
    cancelSetCurrentProject,
    cancelUpdateProject,
    cancelDeleteProject,
    cancelMoveResourcesProject;

export const setInitialProject = (id:number) => ({ type: SET_INITIAL_PROJECT, id });
const fetchProjects = () => ({ type: FETCH_PROJECTS_REQUEST });
const fetchProjectsSuccess = (projects:Project[]) => ({ type: FETCH_PROJECTS_SUCCESS, projects });
const fetchProjectsError = (error:any) => ({ type: FETCH_PROJECTS_FAILURE, error });

const moveProjectResourcesRequest = () => ({ type: MOVE_PROJECT_RESOURCES_REQUEST });
const moveProjectResourcesSuccess = (project:Project) => ({ type: MOVE_PROJECT_RESOURCES_SUCCESS, project });
const moveProjectResourcesError = (error:any) => ({ type: MOVE_PROJECT_RESOURCES_FAILURE, error });

const updateProject = () => ({ type: UPDATE_PROJECT_REQUEST });
const updateProjectSuccess = (id:number, project:Project) => ({ type: UPDATE_PROJECT_SUCCESS, project, id });
const updateProjectError = (error: any) => ({ type: UPDATE_PROJECT_FAILURE, error });

const deleteProject = () => ({ type: DELETE_PROJECT_REQUEST });
const deleteProjectSuccess = (id:number, project:Project) => ({ type: DELETE_PROJECT_SUCCESS, project, id });
const deleteProjectError = (error:any) => ({ type: DELETE_PROJECT_FAILURE, error });

const fetchCurrentProject = () => ({ type: FETCH_CURRENT_PROJECT_REQUEST });
const fetchCurrentProjectSuccess = (project:Project, includeSiteCards: boolean) => ({ type: FETCH_CURRENT_PROJECT_SUCCESS, project, includeSiteCards });
const fetchCurrentProjectError = (error:any) => ({ type: FETCH_CURRENT_PROJECT_FAILURE, error });

const createProject = () => ({ type: CREATE_PROJECT_REQUEST });
const createProjectSuccess = (project:Project) => ({ type: CREATE_PROJECT_SUCCESS, project });
const createProjectError = (error:any) => ({ type: CREATE_PROJECT_FAILURE, error });

const setCurrentProject = () => ({ type: SET_CURRENT_PROJECT_REQUEST });
const setCurrentProjectSuccess = (project:Project) => ({ type: SET_CURRENT_PROJECT_SUCCESS, project });
const setCurrentProjectError = (error:any) => ({ type: SET_CURRENT_PROJECT_FAILURE, error });

export const fetchAllProjects = () => {
    return (dispatch: (arg0: { type: string; projects?: Project[]; error?: any; }) => void) => {
        cancelFetchAllProjects && cancelFetchAllProjects();
        dispatch(fetchProjects());
        return axios.get('/api/projects', {
            cancelToken: new CancelToken((c) => { cancelFetchAllProjects = c; })
        }).then(response => {
            dispatch(fetchProjectsSuccess(response.data));
        }).catch(error => {
            dispatch(fetchProjectsError(error.response));
        });
    };
};

export const fetchCurrentProjectAsync = (includeSiteCards: boolean = false) => {
    return (dispatch: (arg0: { type: string; project?: Project; error?: any; }) => void) => {
        cancelFetchCurrentProject && cancelFetchCurrentProject();
        dispatch(fetchCurrentProject());
        return axios.get(`/api/projects/current`, {
            cancelToken: new CancelToken((c) => { cancelFetchCurrentProject = c; })
        }).then(response => {
            // site cards now listen to this event also
            // dispatch(setSiteCards(response.data.siteCards));
            // delete response.data.siteCards // Remove this from current project as handled in sitecard reducer now
            dispatch(fetchCurrentProjectSuccess(response.data, includeSiteCards));
        }).catch(error => {
            console.log(error);
            dispatch(fetchCurrentProjectError(error.response));
        });
    };
};

export const createProjectAsync = (name: string, visibility: string) => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        // cancelCreateProject && cancelCreateProject();
        dispatch(createProject());
        return axios.post('/api/projects', {
            cancelToken: new CancelToken((c) => { cancelCreateProject = c; }),
            name: name,
            visibility: visibility
        }).then(response => {
            dispatch(createProjectSuccess(response.data));
            dispatch(setCurrentProjectAsync(response.data.id));
            dispatch(setSiteCards([]));
        }).catch(error => {
            dispatch(createProjectError(error.response));
        });
    };
};

export const updateProjectAsync = (id:number, name:string, visibility:string) => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        dispatch(updateProject());
        return axios.patch(`/api/projects/${id}`, {
            cancelToken: new CancelToken((c) => { cancelUpdateProject = c; }),
            name: name,
            visibility: visibility
        }).then((res) => {
            dispatch(updateProjectSuccess(id, res.data));
            dispatch(fetchAllProjects());
            dispatch(fetchCurrentProjectAsync(true));
        })
            .catch((err) => {
                dispatch(updateProjectError(err.response));
            });
    };
};

const moveProjectResourcesAsync = (id:number, backupProjectId:number) => {
    return (dispatch:(dispatch: any) => Promise<void>) => {

    };
};

export const deleteProjectAsync = (id: number, backupProjectId = null) => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        if (backupProjectId !== null) {
            // dispatch(moveProjectResourcesAsync(id, backupProjectId));
            dispatch(moveProjectResourcesRequest());
            axios.post(`/api/projects/${id}/move-resources`, {
                new_project: backupProjectId
            }, {
                cancelToken: new CancelToken((c) => { cancelMoveResourcesProject = c; })
            }).then((res) => {
                dispatch(moveProjectResourcesSuccess(res.data));
                dispatch(deleteProject());
                return axios.delete(`/api/projects/${id}`, {
                    cancelToken: new CancelToken((c) => { cancelDeleteProject = c; })
                }).then((res) => {
                    dispatch(deleteProjectSuccess(id, res.data));
                    dispatch(fetchAllProjects());
                    dispatch(fetchCurrentProjectAsync(false));
                })
                    .catch((err) => {
                        dispatch(deleteProjectError(err.response));
                    });
            }).catch((err) => {
                dispatch(moveProjectResourcesError(err.response));
            });
        } else {
            dispatch(deleteProject());
            return axios.delete(`/api/projects/${id}`, {
                cancelToken: new CancelToken((c) => { cancelDeleteProject = c; })
            }).then((res) => {
                dispatch(deleteProjectSuccess(id, res.data));
                dispatch(fetchAllProjects());
                dispatch(fetchCurrentProjectAsync(false));
            })
                .catch((err) => {
                    dispatch(deleteProjectError(err.response));
                });
        }
    };
};

export const setCurrentProjectAsync = (id:number) => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        // cancelSetCurrentProject && cancelSetCurrentProject();
        dispatch(setCurrentProject());
        return axios.patch(`/api/projects/${id}/current`, {
            cancelToken: new CancelToken((c) => { cancelSetCurrentProject = c; })
        }).then(response => {
            // site cards now listen to this event also
            // dispatch(setSiteCards(response.data.siteCards));
            // delete response.data.siteCards // Remove this from current project as handled in sitecard reducer now
            dispatch(setCurrentProjectSuccess(response.data));
            dispatch(setSiteCards([]));
        }).catch(error => {
            dispatch(setCurrentProjectError(error.response));
        });
    };
};

export const updateKanbanBoardScrollPosition = (scrollPosition: number) => {
    return (dispatch: AppDispatch) => {
        dispatch({type: KANBAN_SCROLL_POSITION_UPDATE, scrollPosition});
    };
};
